import { UserAvailabilityStatus } from './UserAvailabilityStatus'
import { UserRole } from './UserRole'

export class User {
    userId!: string
    companyId!: string
    emailAddress!: string
    jobTitle?: string
    forename!: string
    surname!: string
    userRole!: UserRole
    profilePictureUrl!: string
    status!: UserAvailabilityStatus
    username: string = this.emailAddress
    country!: string
    companyName?: string
}